export default (state = {}, action) => {
  if (action.type === 'on_login') {
    
    return {
      ...action.usuario,
    };
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/usuarioReducer.js